import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

//import { ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatRadioModule } from '@angular/material/radio';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { LayoutModule } from '@angular/cdk/layout';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { PlatformModule } from '@angular/cdk/platform';
import { NgStackFormsModule } from '@ng-stack/forms';

import { PanelComponent, PanelHeaderComponent, PanelFooterComponent, PanelTitle } from './components/panel/panel.component';
import { ToolbarComponent, ToolbarMenuComponent, ToolbarCloseComponent, ToolbarBackComponent } from './components/toolbar/toolbar.component';
import { BoxComponent } from './components/box/box.component';
import { InformationSlideComponent } from './components/information-slide/information-slide.component';
import { PhoneFormComponent } from './components/phone-form/phone-form.component';
import { DialogFormComponent } from './components/dialog-form/dialog-form.component';
import { GoogleMapComponent } from './components/google-map/google-map.component';
import { DialogFullscreenHeaderComponent } from './components/dialog-fullscreen-header/dialog-fullscreen-header.component';
import { SlideToggleComponent, SlideToggleItemComponent } from './components/slide-toggle/slide-toggle.component';
import { NotificationBlockComponent } from './components/notification-block/notification-block.component';
import { DialogUnsavedChangesComponent } from './components/dialog-unsaved-changes/dialog-unsaved-changes.component';
import { UploadFieldComponent, UploadItem } from './components/upload-field/upload-field.component';
import { ContentImageDirective } from './directives/content-image.directive';
import { DialogConfirmComponent } from './components/dialog-confirm/dialog-confirm.component';
import { DialogMessageComponent } from './components/dialog-message/dialog-message.component';
import { HubSubscriptionItem, HubSubscriptionPickerComponent } from './components/hub-subscription-picker/hub-subscription-picker.component';
//import { AdyenCardWebcomponentComponent } from './adyen/adyen-card-webcomponent/adyen-card-webcomponent.component';
import { RadiobuttonItemComponent } from './components/radiobutton-item/radiobutton-item.component';
import { FixedFooterComponent, HideOnKeyboardDirective } from './components/fixed-footer/fixed-footer.component';
import { EditableListComponent, EditableListItemComponent, MetaTableComponent, MetaRowComponent, EditableActionDirective } from './components/editable-list-item/editable-list-item.component';
//import { ActionsDialogComponent } from './adyen/adyen-card-webcomponent/dialogs/actions-dialog/actions-dialog.component';
//import { AdyenRecurringDetailComponentComponent } from './adyen/adyen-recurring-detail-component/adyen-recurring-detail-component.component';
import { SubscriptionPaymentComponent } from './components/subscription-payment/subscription-payment.component';
import { HubClaimComponent } from './components/hub-claim/hub-claim.component';
import { NetseasyCheckoutComponent } from './components/netseasy-checkout/netseasy-checkout.component';
import { NetseasySubscriptionComponent } from './components/netseasy-subscription/netseasy-subscription.component';
import { RedirectComponent } from './guards/redirect.guard';
import { AreaSelectFormComponent } from './components/area-select-form/area-select-form.component';
import { SnapSliderComponent } from './components/snap-slider/snap-slider.component';
import { SortableDirective } from './directives/sortable.directive';
import { GoogleLoginDialogComponent } from './components/google-login-dialog/google-login-dialog.component';
import { FacebookLoginDialogComponent } from './components/facebook-login-dialog/facebook-login-dialog.component';
import { RelativeDatePipe } from './pipes/relative-date-pipe.pipe';
import { BooleanStringPipe } from './pipes/boolean-string.pipe';
import { TimespanFormComponent } from './components/timespan-form/timespan-form.component';
import { NumberControlComponent } from './components/number-control/number-control.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    //ReactiveFormsModule,
    NgStackFormsModule,
    MatInputModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatButtonModule,
    MatMenuModule,
    MatIconModule,
    MatSelectModule,
    MatDialogModule,
    MatProgressBarModule,
    MatRadioModule,
    MatAutocompleteModule,
    MatBottomSheetModule,
    LayoutModule,
    MatSnackBarModule,
    PlatformModule
  ],
  declarations: [
    PanelComponent, PanelHeaderComponent, PanelFooterComponent, PanelTitle,
    ToolbarComponent, ToolbarMenuComponent, ToolbarCloseComponent, ToolbarBackComponent,
    InformationSlideComponent,
    BoxComponent,
    PhoneFormComponent,
    DialogFormComponent,
    GoogleMapComponent,
    DialogFullscreenHeaderComponent,
    SlideToggleComponent,
    SlideToggleItemComponent,
    NotificationBlockComponent,
    DialogUnsavedChangesComponent,
    UploadFieldComponent, UploadItem, ContentImageDirective, DialogConfirmComponent, DialogMessageComponent, HubSubscriptionPickerComponent, HubSubscriptionItem, RadiobuttonItemComponent, FixedFooterComponent, HideOnKeyboardDirective,
    EditableListItemComponent,
    MetaTableComponent,
    MetaRowComponent,
    EditableActionDirective,
    EditableListComponent,
    SubscriptionPaymentComponent,
    HubClaimComponent,
    NetseasyCheckoutComponent,
    NetseasySubscriptionComponent,
    RedirectComponent,
    AreaSelectFormComponent,
    SnapSliderComponent,
    SortableDirective,
    GoogleLoginDialogComponent,
    FacebookLoginDialogComponent,
    RelativeDatePipe,
    BooleanStringPipe,
    TimespanFormComponent,
    NumberControlComponent
  ],
  exports: [
    //ReactiveFormsModule,
    NgStackFormsModule,
    MatInputModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatButtonModule,
    MatMenuModule,
    MatIconModule,
    MatSelectModule,
    MatDialogModule,
    MatRadioModule,
    MatAutocompleteModule,
    MatProgressBarModule,
    MatBottomSheetModule,
    MatSnackBarModule,    
    PanelComponent, PanelHeaderComponent, PanelFooterComponent, PanelTitle,
    InformationSlideComponent,
    ToolbarComponent, ToolbarMenuComponent, ToolbarCloseComponent,ToolbarBackComponent,
    BoxComponent,
    PhoneFormComponent, DialogFormComponent,
    SlideToggleComponent,
    SlideToggleItemComponent,
    GoogleMapComponent,
    DialogFullscreenHeaderComponent,
    NotificationBlockComponent,
    UploadFieldComponent,
    ContentImageDirective,
    HubSubscriptionPickerComponent, HubSubscriptionItem,
    RadiobuttonItemComponent,
    FixedFooterComponent, HideOnKeyboardDirective,
    EditableListItemComponent,
    MetaTableComponent,
    MetaRowComponent,
    EditableActionDirective,
    EditableListComponent,
    SubscriptionPaymentComponent,
    HubClaimComponent,
    NetseasyCheckoutComponent,
    NetseasySubscriptionComponent,
    RedirectComponent,
    LayoutModule,
    AreaSelectFormComponent,
    SnapSliderComponent,
    SortableDirective,
    RelativeDatePipe,
    BooleanStringPipe,
    TimespanFormComponent,
    NumberControlComponent
  ],
  entryComponents: [
    DialogUnsavedChangesComponent,
    DialogConfirmComponent,
    DialogMessageComponent
  ]
})
export class CoreModule { }
